import React from 'react';
import { useTranslation } from '../utils/i18n';
import './SuccessModal.css';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onClose, onConfirm, message }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container">
        <div className="modal-content">
          <div className="modal-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none">
              <circle cx="39" cy="39" r="39" fill="#71BE73"/>
              <path d="M53 31L33.75 50L25 41.3636" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="modal-text">
            {message || t("app.shared.alerts.success.text")}
          </div>
          <div className="modal-actions">
            <button 
              className="btn btn-success"
              onClick={onConfirm}
            >
              {t("app.shared.alerts.success.confirmButtonText")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
